import { SupportBox } from "components/base/support";
import { DDILegendWithText } from "components/ddi_legend";
import { hcpGetAuthInfo, hcpIsLoggedIn, logoutHCP } from "data/hcp-auth";
import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { isInstalled } from "util";
import { useTranslation } from "react-i18next";

const Help = () => {
  const { t } = useTranslation();
  const lastHash = useRef("");
  const nav = useNavigate();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loggedUser, setLoggedUser] = useState(null);
  const [showAppInstall, setShowAppInstall] = useState(false);

  useEffect(() => {
    setIsLoggedIn(hcpIsLoggedIn());
    setLoggedUser(hcpGetAuthInfo());

    if (location.hash) {
      lastHash.current = location.hash.slice(1);
    }
    if (lastHash.current && document.getElementById(lastHash.current)) {
      setTimeout(() => {
        document
          .getElementById(lastHash.current)
          ?.scrollIntoView({ behavior: "smooth", block: "start" });
        lastHash.current = "";
      }, 100);
    }
  }, [location]);

  useEffect(() => {
    isInstalled().then((res) => {
      console.log("Checking instalation returned ", res);
      setShowAppInstall(!res);
    });
  }, []);

  return (
    <>
      <div className="text-center mt-5">
        <h2>{t("auto.comoFunciona", "Como Funciona")}</h2>
      </div>
      <div className="mx-lg-5 text-justified">
        <Row>
          <Col>
            <p>
              {t("auto.aPlataforma", "A plataforma")}{" "}
              <strong>{t("auto.icyclin", "iCyclin")}</strong>{" "}
              {t(
                "auto.foiProjetadaParaOrientarOsMedicosSobrePotenciaisInteracoesMedicamentosasDDIsEntreVariosOsGruposFarmacologicosEOsInibidoresDeCiclinas",
                "foi projetada para orientar os médicos sobre potenciais\n              interações medicamentosas (DDIs) entre vários os grupos farmacológicos e os\n              inibidores de ciclinas.",
              )}
            </p>
            <p>
              {t(
                "auto.estaPlataformaPermiteAoProfissionalDeSaudeSelecionarOMelhorInibidorDeCDKParaASuaDoentePolimedicadaOuPeranteUmDoenteQueJaEstejaEmTratamentoComUmDeterminadoInibidorCDKPerceberQualASuaInteracaoComOutrosMedicamentosgruposFarmacologicos",
                "Esta plataforma permite ao profissional de saúde selecionar o melhor inibidor de CDK para a sua\n              doente polimedicada ou, perante um doente que já esteja em tratamento com um determinado inibidor\n              CDK, perceber qual a sua interação com outros medicamentos/grupos farmacológicos.",
              )}
            </p>
          </Col>
          {showAppInstall && (
            <Col
              xs="12"
              md="4"
              className="text-center border bg-light rounded p-3 app-install"
              onClick={() => nav("/help-install")}
              style={{ cursor: "pointer" }}
            >
              <h6 className="text-secondary fw-bold">
                {t("auto.instaleAAppICyclin", "Instale a app iCyclin")}
              </h6>

              <div className="d-flex flex-column align-items-center justify-content-center">
                <img
                  className="text-center mt-2 mb-2"
                  src="/logo192.png"
                  width="60"
                  height="auto"
                  alt="iCyclin app logo"
                />
                <div className="small text-muted" style={{ fontSize: "12px" }}>
                  {t(
                    "auto.cliqueParaVerComoPodeAdicionarAAppICyclinAoSeuEcraDeEntradaDeFormaATerUmAcessoMaisRapidoESimples",
                    "Clique para ver como pode adicionar a app iCyclin ao seu ecrã de entrada, de forma a ter um acesso\n                  mais rápido e simples.",
                  )}
                </div>
              </div>
            </Col>
          )}
        </Row>
        <DDILegendWithText />
        <hr className="m-4" />
        <p>
          {t(
            "auto.aAnaliseDasInteracoesMedicamentosasPodeSerFeitaDe3Formas",
            "A análise das interações medicamentosas pode ser feita de 3 formas:",
          )}
        </p>
        <ul>
          <li>{t("auto.pesquisaPorFarmaco", "Pesquisa por fármaco")}</li>
          <li>
            {t(
              "auto.pesquisaPorGrupoFarmacologico",
              "Pesquisa por grupo farmacológico",
            )}
          </li>
          <li>
            {t("auto.analiseDePerfilDeDoente", "Análise de perfil de doente")}
          </li>
        </ul>
        <h3 className="text-start mt-5">
          {t("auto.pesquisaPorFarmaco", "Pesquisa por Fármaco")}
        </h3>
        <ul>
          <li>
            {t(
              "auto.pesquiseONomeDoFarmacoDigiteONomeDoMedicamentoNaBarraDePesquisa",
              "Pesquise o nome do Fármaco - Digite o nome do medicamento na barra de pesquisa.",
            )}
          </li>
          <li>
            {t(
              "auto.apareceraOMedicamentoCorrespondenteASuaPesquisaEDeQueFormaEsteMedicamentoInterageComOsInibidoresDeCDK",
              "Aparecerá o medicamento correspondente à sua pesquisa, e de que forma este medicamento\n            interage com os inibidores de CDK.",
            )}
          </li>
        </ul>
        <h3 className="text-start mt-5">
          {t(
            "auto.pesquisaPorGrupoFarmacologico",
            "Pesquisa por Grupo Farmacológico",
          )}
        </h3>
        <ul>
          <li>
            {t("auto.aoClicarNoBotao", "Ao clicar no botão")}{" "}
            <em>{t("auto.grupoFarmacologico", "Grupo Farmacológico")}</em>{" "}
            {t(
              "auto.iraoAparecerTodosOsGruposFarmacologicos",
              "irão aparecer todos os grupos\n            farmacológicos",
            )}
          </li>
          <li>
            {t(
              "auto.selecioneOGrupoFarmacologicoQuePretendeVerificarAsInteracoesMedicamentosas",
              "Selecione o grupo farmacológico que pretende verificar as interações medicamentosas.",
            )}
          </li>
          <li>
            {t(
              "auto.aoSelecionarUmGrupoFarmacologicoApareceraUmaListaComTodosOsFarmacosDesseGrupoClassificadosDeAcordoComASuaSegurancaAoInteragirComInibidoresDeCiclinas",
              "Ao selecionar um grupo farmacológico aparecerá uma lista com todos os fármacos desse\n            grupo classificados de acordo com a sua segurança ao interagir com inibidores de ciclinas.",
            )}
          </li>
          <li>
            {t(
              "auto.paraFecharEsteGrupoPoderaClicartocarNoCabecalhoDoMesmoOuSimplesmenteSelecionarOutroGrupo",
              "Para fechar este grupo, poderá clicar/tocar no cabeçalho do mesmo, ou simplesmente selecionar outro grupo.",
            )}
          </li>
        </ul>

        <h3 className="text-start mt-5">
          {t("auto.analiseDePerfilDeDoente", "Análise de Perfil de Doente")}
        </h3>
        <p>
          {t(
            "auto.estaAplicacaoPermitelheTambemAnalisarUmPerfilDeDoentePolimedicadaFicandoComUmaMelhorPerspetivaDasDiferentesInteracoesMedicamentosasNumaDoenteEmParticular",
            "Esta aplicação permite-lhe também analisar um perfil de doente polimedicada, ficando com uma melhor perspetiva\n          das diferentes interações medicamentosas numa doente em particular.",
          )}
          <br />
        </p>
        <ul>
          <li>
            {t(
              "auto.selecioneOsMedicamentosQuePretendeAdicionarAoSeuPerfilDeDoenteClicandoNoIcone",
              "Selecione os medicamentos que pretende adicionar ao seu perfil de doente clicando no ícone",
            )}{" "}
            <span className="badge fs-6 rounded-pill bg-primary">
              <i className="bi bi-person-fill-add" />
            </span>
            .
          </li>
          <li>
            {t(
              "auto.apareceraUmaCaixaComONovoPerfilDeDoenteEFarmacosSelecionados",
              "Aparecerá uma caixa com o novo perfil de doente e fármacos selecionados",
            )}
            <br />
            <img
              src={require("img/ajuda-perfil-doente.png")}
              height="200"
              width="auto"
              alt="exemplo pefil doente"
            />
          </li>
          <li>
            {t(
              "auto.casoPretendaRemoverUmMedicamentoAposOTerAdicionadoAoSeuPerfilDeDoenteCliqueNaLinhaDoFarmacoCorrespondenteNoIcone",
              "Caso pretenda remover um medicamento, após o ter adicionado ao seu perfil de doente, clique na linha do\n            fármaco correspondente, no ícone",
            )}{" "}
            <span className="badge fs-6 rounded-pill bg-primary">
              <i className="bi bi-x" />
            </span>{" "}
          </li>
          <li>
            {t("auto.clicandoNoIcone", "Clicando no ícone")}{" "}
            <span className="badge fs-6 rounded-pill bg-primary">
              <i className="bi bi-arrow-left-right" />
            </span>
            {t(
              "auto.PoderaEncontrarUmaAlternativaComMenosInteracoesMedicamentosasDentroDoMesmoGrupoFarmacologico",
              ", poderá encontrar uma alternativa com menos interações medicamentosas, dentro do mesmo grupo farmacológico.",
            )}
          </li>
          <li className="mt-3">
            {t(
              "auto.aoFecharEstePerfilDeDoenteNoIcone",
              "Ao fechar este perfil de doente, no ícone",
            )}{" "}
            <span className="badge fs-6 rounded-pill bg-primary">
              <i className="bi bi-x" />
            </span>{" "}
            {t(
              "auto.deTopoTodosOsFarmacosSeraoRemovidosAutomaticamentePoderaEntaoIniciarUmaNovaSelecaoDeFarmacos",
              "de topo, todos os fármacos serão removidos automaticamente. Poderá então iniciar uma nova seleção de\n            fármacos.",
            )}
          </li>
        </ul>
        <hr className="m-4 mt-5" />
        <div>
          <p>
            <strong>
              {t(
                "auto.estasFuncionalidadesSaoDeUtilizacaoExclusivaParaProfissionaisDeSaude",
                "Estas funcionalidades são de utilização exclusiva para profissionais de saúde.",
              )}
            </strong>
          </p>

          <p>
            {t(
              "auto.quandoTentarAcederAsMesmasSerlheaPedidaInformacaoNomeProfissaoNDeCedulaProfissionalDeFormaAQuePossamosValidarAsSuasCredenciaisPeranteAOrdemDosMedicosFarmaceuticosOuEnfermeirosEstaValidacaoEEfetuadaUmaUnicaVezEmCadaDispositivoEOsSseusDadosSaoGuardadosExclusivamenteNoSeuBrowser",
              "Quando tentar aceder às mesmas, ser-lhe-á pedida informação (Nome, Profissão, Nº de cédula profissional) de\n            forma a que possamos validar as suas credenciais perante a Ordem dos Médicos, Farmacêuticos ou Enfermeiros.\n            Esta validação é efetuada uma única vez em cada dispositivo e os sseus dados são guardados exclusivamente no\n            seu browser.",
            )}
          </p>
          {isLoggedIn && (
            <div className="container">
              {t(
                "auto.temJaUmaSessaoAtivaComOSeuRegistoValidadoComOsSeguintesDados",
                "Tem já uma sessão ativa, com o seu registo validado com os seguintes dados:",
              )}{" "}
              <ul>
                <li>
                  {t("auto.nome", "Nome")}: <strong>{loggedUser?.name}</strong>
                </li>
                <li>
                  {t("auto.profissao", "Profissão")}:{" "}
                  <strong>{loggedUser?.job}</strong>
                </li>
                <li>
                  {t("auto.nDeOrdem", "Nº de Ordem")}:{" "}
                  <strong>{loggedUser?.licenseNumber}</strong>
                </li>
              </ul>
              <p>
                {t(
                  "auto.poderaTerminarASuaSessaoNoBotaoAbaixo",
                  "Poderá terminar a sua sessão no botão abaixo:",
                )}
              </p>
              <div>
                <Button
                  variant="outline-primary"
                  className="text-center"
                  onClick={() => {
                    if (
                      !window.confirm(
                        "Tem a certeza que deseja terrminar a sua sessão?\nTerá de voltar a validar os seus dados profissionais de forma a obter novamente acesso.",
                      )
                    )
                      return;
                    logoutHCP();
                    nav("/");
                  }}
                >
                  {t("auto.terminarSessao", "Terminar Sessão")}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      <hr className="m-4 mt-5" id="support" />
      <div>
        <SupportBox />
      </div>
    </>
  );
};

export default Help;
